import { z } from "zod";
import type { NotificationTopic } from "../notifications";

/** GET /v1/me/notifications — uygulama içi bildirimler (metin sunucuda üretilir, kullanıcının dilinde) */
export interface NotificationView {
  id: string;
  template: string;
  title: string;
  body: string;
  path: string;
  createdAt: string;
  readAt: string | null;
}
export interface NotificationsResponse {
  notifications: NotificationView[];
  unread: number;
  /** sonraki sayfa için `before` değeri */
  nextBefore: string | null;
}

/** POST /v1/me/notifications/read */
export const MarkReadBody = z.union([
  z.object({ ids: z.array(z.string().uuid()).min(1).max(100) }),
  z.object({ all: z.literal(true) }),
]);
export type MarkReadBody = z.infer<typeof MarkReadBody>;

/** GET/PUT /v1/me/notification-preferences — e-posta konuları (uygulama içi her zaman açık) */
export const NOTIFICATION_TOPICS = [
  "task",
  "payment",
  "payout",
  "account",
  "message",
] as const satisfies readonly NotificationTopic[];
export const NotificationPreferencesBody = z.object({
  email: z.object(
    Object.fromEntries(NOTIFICATION_TOPICS.map((t) => [t, z.boolean().optional()])) as Record<
      NotificationTopic,
      z.ZodOptional<z.ZodBoolean>
    >,
  ),
});
export type NotificationPreferences = { email: Record<NotificationTopic, boolean> };
